export default "<router-outlet></router-outlet>";